import { AntDesign } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import React from "react";
import { useCallback } from "react";
import { useTheme } from "@towersystems/roam-common-native";
import { SellScreenProps } from "../../../../screens/SellScreen";
import { useSaleControllerProvider } from "../../../../utils/sale-controller";
import { QuickKey, QuickKeyProps } from "../../../QuickKey";

export type SaleNoteQuickKeyProps = QuickKeyProps & {};

export const SaleNoteQuickKey = React.forwardRef<any, QuickKeyProps>(
  ({ disabled: _disabled, ...props }, ref) => {
    const { sale } = useSaleControllerProvider();
    const { colors: Colors } = useTheme();
    const navigation = useNavigation<SellScreenProps["navigation"]>();

    const disabled = _disabled !== undefined ? _disabled : !sale;
    const hasNote = Boolean(sale?.note);

    const title = hasNote ? "Edit Staff Note" : "Add Staff Note";

    const onPress = useCallback(() => {
      if (disabled) return;
      navigation.navigate("ActionsRootScreen", {
        screen: "EditSaleNoteScreen",
      });
    }, [disabled]);

    return (
      <QuickKey
        ref={ref}
        disabled={disabled}
        label={title}
        onPress={onPress}
        subtitle={hasNote ? sale?.note : ""}
        iconPrimary={
          <AntDesign
            name="form"
            size={24}
            color={disabled ? Colors.white : Colors.quickKeyActionText}
          />
        }
        backgroundColor={Colors.action}
        isAction={true}
        {...props}
      />
    );
  }
);
